import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-get-samples-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class ControlGetSamplesApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.controlGetSamplesApi"),
            httpMethod: "GET",
            path: "/controls/testing/advanced/effectiveness/{effectivenessGuid}/automation/samples",

            parameters: [
                {
                    name: "effectivenessGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: [
                        {
                            documents: [
                                {
                                    guid: "uuid",
                                    name: "string",
                                }
                            ],
                            testSteps: [
                                {
                                     documents: [
                                        {
                                            guid: "uuid",
                                            name: "string",
                                        }
                                    ],
                                    testStepId: "uuid",
                                    testStepName: "string",
                                    requiredDocuments: "string",
                                },
                            ],
                            testSampleId: "uuid",
                            testSampleName: "string",
                        },
                    ],
                },
            ],
        };
    }
}
